import React from 'react';

// タイトルをフォーマットする関数
export const formatTitle = (title: string) => {
  return title.split(' ').map((part, index) => (
    <React.Fragment key={index}>
      {part}
      {index < title.split(' ').length - 1 && <br />}
    </React.Fragment>
  ));
};